module.exports = __webpack_public_path__ + "img/rei-docusign-logos.a319e499.png";